module.exports = __webpack_public_path__ + "static/img/home-battery-01@tw.dea15b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/home-battery-01@tw.jpg
// module id = e873
// module chunks = 0